export default {
	subtitle: "Confirm 3DS Credit Card Transaction in Colombia",
  path: "transaction_cc_col_confirmation",
	paragraphs: ["When your customer is prompted for an OTP (one-time password), the transaction you created in the previous step will be held on pending until this step is done. Once that OTP is entered and confirmed, this endpoint needs to be called in the sequence.", "If the process is successfully complete, you will have an 'identified' status transaction. Otherwise, it will be canceled. In this case you can check what happened in the 'errors' or 'payment_failed' field.", "Note: if you are using the HTML sample page, this part will be done automatically and any errors will be presented on pop-ups.", "Notice that in sandbox, this scenario can be simulated by making a transaction greater than 100000 COP."],
  request: {
    method: "POST",
    endpoint: "/transactions/:id/confirm_threeds",
    responses: {
      "data": {
        "value": "200000.00",
        "to_bank_account": {
          "routing_number": "Further Credit To / REF: SWS2319371",
          "pix_info": null,
          "owner_name": "REARDEN STEEL CO. Ltd.",
          "owner_document_number": "2348909854385",
          "owner_company": {
            "social_name": "POWER HOME THEATER",
            "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
            "document_type": "tax_id",
            "document_number": "2348909854385"
          },
          "nickname": "Power Conta 1",
          "intermediary_bank_account": null,
          "id": "a1db04a1-ddc9-4aa8-a0a5-2c74cf9505d0",
          "iban": null,
          "currency": "USD",
          "branch_number": null,
          "branch_country": "COL",
          "bank": {
            "swift": "MT2502041",
            "name": "M&T Bank",
            "id": "d6f801e9-57c0-43af-8b11-07b8bd4fff0f",
            "country": null,
            "code": null
          },
          "account_type": "conta-corrente",
          "account_number": "00416612332",
          "aba": null
        },
        "subject_is_receiver": false,
        "subject_id": "9e474282-8b37-4d05-9c77-eab27976cfe9",
        "subject": {
          "updated_at": "2024-02-05T19:20:24.196893",
          "status": "approved",
          "social_name": "HORACIO SOTO MORALES",
          "rfc_pf": null,
          "required_clearance_level": 2,
          "phone_number": "434898404898",
          "net_monthly_average_income": "50000.00",
          "inserted_at": "2021-03-26T20:22:04.358980",
          "id": "9e474282-8b37-4d05-9c77-eab27976cfe9",
          "fiscal_country": "Colombia",
          "email": "horacio@gmail.com",
          "document_type": "cc",
          "document_number": "1037633285",
          "clearance_level": 2,
          "birth_date": null,
          "address_street": "Calle Cannobio",
          "address_state": "PS",
          "address_postal_code": "39847389",
          "address_number": "75",
          "address_neighborhood": "Aldea Alpina",
          "address_country": "Colombia",
          "address_complement": "",
          "address_city": "Nuova Lima"
        },
        "status": "identified",
        "source_name": "HORACIO SOTO MORALES",
        "source_document_type": "cc",
        "source_document_number": "1037633285",
        "meta": null,
        "inserted_at": "2024-02-05T19:20:24.172547",
        "id": "a7ade569-2c89-40b4-8ec4-65a30cb7eacf",
        "from_credit_card": {
          "status": "tokenized",
          "inserted_at": "2024-02-05T19:20:24.171366",
          "id": "5a5aa8b2-fcf1-4e98-85a3-e349cd72c374"
        },
        "from_bank_account": null,
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "COP",
        "cleared": true,
        "bank_transaction": {
          "wire_id": null,
          "value": "2002.0",
          "spei_reference": null,
          "spei_concepto_de_pago": null,
          "source_type": "CREDIT CARD",
          "source_name": "HORACIO SOTO MORALES",
          "source_id": "48a01ee3-5132-41b7-8f07-7248a1101374",
          "source_document_type": "cc",
          "source_document_number": "1037633285",
          "source_description": "PAGAMENTO POR CARTAO",
          "source_branch": null,
          "source_bank": null,
          "source_account": null,
          "movement_date": "2024-02-05",
          "iof_value": null,
          "inserted_at": "2024-02-05T19:23:55.510552",
          "id": "a081e257-cfeb-4aea-9f77-e8b8bf8682ed",
          "exchanged_value": null,
          "exchange_rate_spot": null,
          "exchange_rate": null,
          "exchange_id": null,
          "exchange_currency": "USD",
          "exchange_approved": false,
          "currency": "COP"
        }
      }
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "ID of the transaction created in the previous step"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardCOLConfirmation.js